<agr-page-toolbar
  [pageTitle]="'cycles' | translate"
  [isEmpty]="(cycles$ | async)?.length === 0"
  [emptyTitle]="'no-cycles-title' | translate"
  [emptyDescription]="'no-cycles-description' | translate"
  emptyImage="assets/images/flock-cycle.jpg"
  data-test="cycle-overview"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'cycle-overview.start-new-cycle' | translate"
  (primaryAction)="addCycle()"
>
  <ng-container actions>
    <mat-slide-toggle
      [hideIcon]="true"
      data-test="cycle-overview__toggleDetailedOverview"
      color="primary"
      [checked]="isDetailedOverview$ | async"
      class="text--small spacing--padding-right"
      (change)="toggleDetailedOverview()"
      labelPosition="after"
    >
      {{ 'cycle-overview.detailedOverview' | translate }}
    </mat-slide-toggle>

    <div class="mat-toolbar__right" *ngIf="(isMobile$ | async) && (isDetailedOverview$ | async)">
      <button
        class="margin-right"
        mat-icon-button
        (click)="deleteCycle(selectedCycle)"
        data-test="cycle-overview__delete-cycle--mobile"
      >
        <mat-icon>delete</mat-icon>
      </button>

      <button
        class="margin-right"
        mat-icon-button
        (click)="editCycle(selectedCycle)"
        data-test="cycle-overview__edit-cycle--mobile"
      >
        <mat-icon>create</mat-icon>
      </button>
    </div>
  </ng-container>

  <app-cycle-overview-detailed
    *ngIf="(isDetailedOverview$ | async) === true; else simpleOverview"
    [isMobile]="isMobile$ | async"
    (deleteClicked)="deleteCycle($event)"
    (editClicked)="editCycle($event)"
  >
  </app-cycle-overview-detailed>

  <ng-template #simpleOverview>
    <app-cycle-overview-simple (deleteClicked)="deleteCycle($event)"> </app-cycle-overview-simple>
  </ng-template>
</agr-page-toolbar>
